import { INotificationMessage, NotificationMessageType } from ".";
import { createAction, createStandardAction } from "typesafe-actions";

export const RAISE_NOTIFICATION_MESSAGE = 'RAISE_NOTIFICATION_MESSAGE';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';


//actions
export const raiseNotification = createStandardAction(RAISE_NOTIFICATION_MESSAGE).map(
	(message: INotificationMessage) => ({ message })
);

export const clearNotifications = createAction(CLEAR_NOTIFICATIONS);

export const raiseError = (title: string, details?: string, actions?: any) => raiseNotification({ type: NotificationMessageType.error, title, details, actions })
export const raiseSuccess = (title: string, details?: string, actions?: any) => raiseNotification({ type: NotificationMessageType.confirm, title, details, actions })
export const raiseWarning = (title: string, details?: string, actions?: any) => raiseNotification({ type: NotificationMessageType.warn, title, details, actions })
export const raiseInformation = (title: string, details?: string, actions?: any) => raiseNotification({ type: NotificationMessageType.info, title, details, actions })



// WEBPACK FOOTER //
// ./src/store/modules/notifications/actions.ts